module.exports = __webpack_public_path__ + "static/media/festival.cb9b720d.png";